var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip-box cursor-pointer"},[_vm._t("default"),_vm._v(" "),_c('div',{class:'tooltip' + (_vm.position ? ' ' + _vm.position : '')},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }